export enum ProfessionalField {
    None = 0x000000,

    AkisIInovacije = 0x000001,

    Ratarstvo = 0x000002,

    Stocarstvo = 0x000004,

    DiverzifikacijaPoljoprivredneProizvodnje = 0x000008,

    Agroekonomika = 0x000010,

    EkoloskaPoljoprivreda = 0x000020,

    ZastitaBilja = 0x000040,

    KlimaIOkolis = 0x000080,

    DopunskeDjelatnosti = 0x000100,

    MehanizacijaIDigitalizacija = 0x000200,

    VinogradarstvoIVinarstvo = 0x000400,

    Vocarstvo = 0x000800,

    Vrtlarstvo = 0x001000,
}

export const ProfessionalFieldFilterFields: Record<
    string,
    { value: number; label: string }
> = {
    None: { value: ProfessionalField.None, label: "None" },

    AkisIInovacije: {
        value: ProfessionalField.AkisIInovacije,
        label: "AKIS i inovacije",
    },

    Ratarstvo: { value: ProfessionalField.Ratarstvo, label: "Ratarstvo" },

    Stocarstvo: { value: ProfessionalField.Stocarstvo, label: "Stočarstvo" },

    DiverzifikacijaPoljoprivredneProizvodnje: {
        value: ProfessionalField.DiverzifikacijaPoljoprivredneProizvodnje,
        label: "Diverzifikacija poljoprivredne proizvodnje",
    },

    Agroekonomika: {
        value: ProfessionalField.Agroekonomika,
        label: "Agroekonomika",
    },

    EkoloskaPoljoprivreda: {
        value: ProfessionalField.EkoloskaPoljoprivreda,
        label: "Ekološka poljoprivreda",
    },

    ZastitaBilja: {
        value: ProfessionalField.ZastitaBilja,
        label: "Zaštita bilja",
    },

    KlimaIOkolis: {
        value: ProfessionalField.KlimaIOkolis,
        label: "Klima i okoliš",
    },

    DopunskeDjelatnosti: {
        value: ProfessionalField.DopunskeDjelatnosti,
        label: "Dopunske djelatnosti",
    },

    MehanizacijaIDigitalizacija: {
        value: ProfessionalField.MehanizacijaIDigitalizacija,
        label: "Mehanizacija i digitalizacija u poljoprivredi",
    },

    VinogradarstvoIVinarstvo: {
        value: ProfessionalField.VinogradarstvoIVinarstvo,
        label: "Vinogradarstvo i vinarstvo",
    },

    Vocarstvo: { value: ProfessionalField.Vocarstvo, label: "Voćarstvo" },

    Vrtlarstvo: { value: ProfessionalField.Vrtlarstvo, label: "Vrtlarstvo" },
};